<template
  ><section class="gm-panel">
    <div class="gm-header">
      <div>
        <h2>Subscribers</h2>
        <p class="gm-muted">
          GrooveMail contact records for this form. Queued submissions may take
          a moment to appear.
        </p>
      </div>
      <gs-button variant="outline" @click="load">Refresh</gs-button>
    </div>
    <p v-if="error" class="gm-error" role="alert">{{ error }}</p>
    <p v-else-if="loading" role="status">Loading subscribers…</p>
    <div v-else-if="rows.length" class="gm-table-wrap">
      <table class="gm-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>First submitted</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>{{ row.name || '—' }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.status }}</td>
            <td>{{ date(row.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else class="gm-muted">
      No subscribers yet. Publish the form and share its link or embed it on
      your page.
    </p>
    <div class="gm-actions" style="margin-top:16px">
      <gs-button
        variant="outline"
        :disabled="page === 1 || loading"
        @click="
          page--;
          load();
        "
        >Previous</gs-button
      ><small>Page {{ page }} of {{ lastPage }}</small
      ><gs-button
        variant="outline"
        :disabled="page >= lastPage || loading"
        @click="
          page++;
          load();
        "
        >Next</gs-button
      >
    </div>
  </section></template
>
<script>
import axios from 'axios';
import { errorMessage } from './contracts';
export default {
  props: { id: { type: String, required: true } },
  data: () => ({ rows: [], error: '', loading: false, page: 1, lastPage: 1 }),
  created() {
    this.load();
  },
  methods: {
    date(value) {
      return new Date(value).toLocaleString();
    },
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get(
          '/studio/forms/' + this.id + '/subscribers',
          { params: { page: this.page } }
        );
        this.rows = response.data.data;
        this.lastPage = response.data.last_page;
      } catch (error) {
        this.error = errorMessage(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
